module.exports = {"pages":{}}


//////////////////
// WEBPACK FOOTER
// ./app/locales/pages.ru.json
// module id = 1107
// module chunks = 4